export { SaleDetail } from './sale-detail'
